'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _pipe = require('ramda/src/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _map = require('ramda/src/map');

var _map2 = _interopRequireDefault(_map);

var _filter = require('ramda/src/filter');

var _filter2 = _interopRequireDefault(_filter);

var _length = require('ramda/src/length');

var _length2 = _interopRequireDefault(_length);

var _equals = require('ramda/src/equals');

var _equals2 = _interopRequireDefault(_equals);

var _head = require('ramda/src/head');

var _head2 = _interopRequireDefault(_head);

var _both = require('ramda/src/both');

var _both2 = _interopRequireDefault(_both);

var _complement = require('ramda/src/complement');

var _complement2 = _interopRequireDefault(_complement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dropdown = function (_Component) {
    _inherits(Dropdown, _Component);

    function Dropdown() {
        _classCallCheck(this, Dropdown);

        var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).apply(this, arguments));

        _this.state = { active: false, currentValue: {} };
        _this.topContainer = null;
        _this.onBodyClick = function (ev) {
            var active = _this.state.active;

            if (_this.topContainer == null) {
                return;
            }
            if (_this.topContainer.contains(ev.target) === false && active === true) {
                _this.setState({ active: false });
            }
        };
        _this.addClass = function () {
            _this.setState(function (prevState) {
                return { active: !prevState.active };
            });
        };
        _this.updateCurrentValue = function (value) {
            var onChange = _this.props.onChange;

            _this.setState({ currentValue: value, active: false });
            if (onChange) {
                onChange(value);
            }
        };
        _this.keyEsc = function (e) {
            if (e.keyCode === 27) {
                _this.setState({ active: false });
            }
        };
        _this.mapItems = function (items) {
            return (0, _pipe2.default)((0, _filter2.default)(_this.isOptionNotSelected), (0, _map2.default)(_this.createItem))(items);
        };
        _this.createItem = function (option) {
            var currentValue = _this.state.currentValue;

            return _react2.default.createElement("li", { key: option.name, onClick: function onClick() {
                    return _this.updateCurrentValue(option);
                }, role: "presentation" }, _react2.default.createElement("button", { type: "button", className: "luna-dropdown__action", role: "option", "aria-selected": currentValue === option }, option.name));
        };
        _this.renderItems = function (data) {
            var children = _this.props.children;

            if (_this.isSingle()) {
                return _this.mapItems(data);
            }
            return _react2.default.Children.map(children, function (child) {
                if (!_react2.default.isValidElement(child)) {
                    return null;
                }
                return _react2.default.cloneElement(child, {
                    closeDropdown: function closeDropdown() {
                        return _this.setState({ active: false });
                    }
                });
            });
        };
        _this.isSingle = function () {
            var children = _this.props.children;

            return (0, _equals2.default)(_react.Children.count(children), 0);
        };
        _this.isOptionSelected = function (option) {
            var currentValue = _this.state.currentValue;

            return (0, _equals2.default)(option.name, currentValue.name);
        };
        // eslint-disable-next-line react/sort-comp
        _this.isOptionNotSelected = (0, _complement2.default)(_this.isOptionSelected);
        _this.isOnlyOneOption = (0, _pipe2.default)(_length2.default, (0, _equals2.default)(1));
        _this.isOnlyOneOptionAndIsSelcted = (0, _both2.default)(_this.isOnlyOneOption, (0, _pipe2.default)(_head2.default, _this.isOptionSelected));
        _this.isSingleAndOnlyOneOptionAndIsSelected = (0, _both2.default)(_this.isSingle, _this.isOnlyOneOptionAndIsSelcted);
        _this.onRef = function (ref) {
            _this.topContainer = ref;
        };
        return _this;
    }

    _createClass(Dropdown, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var defaultValue = this.props.defaultValue;

            this.setState({
                currentValue: defaultValue || {}
            });
            document.addEventListener('click', this.onBodyClick);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props = this.props,
                selectedItems = _props.selectedItems,
                input = _props.input,
                defaultValue = _props.defaultValue;

            if (selectedItems && nextProps.selectedItems && selectedItems.length !== nextProps.selectedItems.length && input != null) {
                input.onBlur(nextProps.selectedItems);
            }
            if (defaultValue && nextProps.defaultValue && defaultValue.name !== nextProps.defaultValue.name) {
                this.updateCurrentValue(nextProps.defaultValue);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.onBodyClick);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                data = _props2.data,
                placeholder = _props2.placeholder,
                className = _props2.className;
            var _state = this.state,
                active = _state.active,
                currentValueName = _state.currentValue.name;

            return _react2.default.createElement("div", { ref: this.onRef }, _react2.default.createElement("div", { onKeyDown: this.keyEsc, className: (0, _classnames2.default)('luna-dropdown', {
                    'is-visible': active,
                    'luna-dropdown--no-options': this.isSingleAndOnlyOneOptionAndIsSelected(data)
                }, className), role: "button" }, _react2.default.createElement("button", { onClick: this.addClass, className: "luna-dropdown__trigger luna-select", "aria-controls": "dropdown-menu-1", "aria-expanded": active.toString(), type: "button", "aria-haspopup": "true", "aria-label": "Select one from the following options" }, currentValueName || placeholder), this.isSingleAndOnlyOneOptionAndIsSelected(data) ? null : _react2.default.createElement("ul", { className: "luna-dropdown__menu", id: "dropdown-menu-1", role: "listbox" }, this.renderItems(data))));
        }
    }]);

    return Dropdown;
}(_react.Component);

Dropdown.propTypes = {
    placeholder: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        name: _propTypes2.default.string
    })).isRequired,
    defaultValue: _propTypes2.default.shape({
        name: _propTypes2.default.string
    }).isRequired,
    onChange: _propTypes2.default.func.isRequired,
    className: _propTypes2.default.string.isRequired,
    selectedItems: _propTypes2.default.node.isRequired,
    input: _propTypes2.default.node.isRequired,
    children: _propTypes2.default.node.isRequired
};
Dropdown.defaultProps = {
    placeholder: 'Select'
};
exports.default = Dropdown;
//# sourceMappingURL=Dropdown.js.map